<div class="position-relative h-100">
  <ng-container>
    @if (variant() === 'card') {
      <wl-commodity-offer-card
        [offer]="offer()"
        [showLoadingState]="showLoadingState()"
      >
        <div class="mb-2">
          <essent-commodity-offer-header
            [addLabelSpacer]="ensureHorizontalAlignment()"
            [duration]="offer()?.durationTitle"
            [productTitle]="offer()?.productTitle"
            [incentive]="offer()?.incentiveTitle"
            [highlight]="offer()?.isHighlightedLabel"
            [isDynamicProduct]="!!offer()?.isDynamicProduct"
            [dynamicPricingTitle]="offer()?.dynamicPricingTitle"
            [showPriceTag]="false"
            [enableNewOfferCardTitles]="enableNewOfferCardTitles()"
            [termijnbedragVariantA]="termijnbedragVariantA()"
            [termijnbedragVariantB]="termijnbedragVariantB()"
            [promoCode]="promoCodeBadge()"
          />
        </div>
        <div class="d-flex flex-column flex-grow-1">
          <ng-container *ngTemplateOutlet="offerBody" />
        </div>
      </wl-commodity-offer-card>
    }

    @if (variant() === 'accordion') {
      <wl-commodity-offer-accordion
        [offer]="offer()"
        [opened]="active()"
        [showLoadingState]="showLoadingState()"
      >
        <ng-template #accordionHeader>
          <essent-commodity-offer-header
            [addLabelSpacer]="false"
            [duration]="offer()?.durationTitle"
            [productTitle]="offer()?.productTitle"
            [priceDurationLabel]="content()?.priceDurationLabel"
            [priceDurationAlternateLabel]="
              content()?.priceDurationAlternateLabel
            "
            [withDiscountAlternateLabel]="content()?.withDiscountAlternateLabel"
            [price]="offer()?.expectedMonthlyAmount"
            [incentive]="offer()?.incentiveTitle"
            [highlight]="offer()?.isHighlightedLabel"
            [isDynamicProduct]="!!offer()?.isDynamicProduct"
            [dynamicPricingTitle]="offer()?.dynamicPricingTitle"
            [showPriceTag]="true"
            [enableNewOfferCardTitles]="enableNewOfferCardTitles()"
            [termijnbedragVariantA]="termijnbedragVariantA()"
            [termijnbedragVariantB]="termijnbedragVariantB()"
            [promoCode]="promoCodeBadge()"
          />
        </ng-template>
        <ng-template #accordionBody>
          <ng-container *ngTemplateOutlet="offerBody"></ng-container>
        </ng-template>
      </wl-commodity-offer-accordion>
    }
  </ng-container>
</div>

<ng-template #offerBody>
  @if (variant() === 'accordion') {
    <div
      class="d-flex justify-content-between"
      [ngClass]="
        termijnbedragVariantB() &&
        content()?.monthlyCostsAdditionalLabel?.length &&
        offer()?.incentiveTitle
          ? ''
          : 'mb-2'
      "
    >
      <div>{{ content()?.proposedBudgetBillBefore }}</div>
      <div>
        <span [ngClass]="termijnbedragVariantB() ? '' : 'fw-bold'">{{
          offer()?.budgetBillAmount! | roundedCurrency
        }}</span>
        <span [ngClass]="termijnbedragVariantA() ? 'fw-bold' : ''"
          >&nbsp;{{
            termijnbedragVariantB()
              ? content()?.priceDurationAlternateLabel
              : content()?.priceDurationLabel
          }}</span
        >
      </div>
    </div>
    @if (
      termijnbedragVariantB() &&
      content()?.monthlyCostsAdditionalLabel?.length &&
      offer()?.incentiveTitle
    ) {
      <div class="d-flex gap-1 mb-2">
        <span class="">
          {{ content()?.monthlyCostsAdditionalLabel }}
        </span>
      </div>
    }
  }

  @if (!useAlternateCommodityTariffView()) {
    <wl-commodity-offer-view-tariffs
      [tariffModalDescriptionLabel]="content()?.tariffModalDescriptionLabel"
      [tariffModalLinkTextLabel]="content()?.tariffModalLinkTextLabel"
      [centerAlignedTariffLink]="centerAlignedTariffLink()"
      (viewTariffs)="viewTariffs.emit()"
    />
  }
  @if (!hideCommodityProductBreakdownTable()) {
    <essent-commodity-product-breakdown
      [offer]="offer()"
      [content]="content()"
      [showMemberGetMember]="showMemberGetMember()"
    />
  }
  <div class="flex-grow-1"></div>
  @if (useAlternateCommodityTariffView()) {
    <div class="d-block text-center mt-2">
      <ed-commodity-vertical-offer-dropdown
        [offer]="offer()"
        [content]="content()"
        (viewTariffs)="viewTariffs.emit()"
        [expanded]="showTariffs()"
        (expand)="openTariffDropdown.emit()"
        (collapse)="closeTariffDropdown.emit()"
      />
    </div>
  }

  @if (variant() === 'card') {
    <wl-commodity-offer-price-tag
      [offer]="offer()"
      [content]="content()"
      class="mt-2"
    />
  }

  <div class="d-flex flex-column">
    @if (content()?.costEstimationLabel; as costEstimationLabel) {
      <div
        class="text-center mt-2"
        *wlGenericRichText="{ value: costEstimationLabel }"
        wlCSCapture
      ></div>
    }

    <crnt-button-alt
      variant="primary"
      class="mt-2"
      (click)="selectOffer.emit()"
      wlAutomationId="offer-submit-button"
      wlCSCapture
    >
      {{ content()?.offerSubmitButtonLabel }}
      <crnt-icon slot="trailing" icon="angle-right"></crnt-icon>
    </crnt-button-alt>
    @if (content()?.moreInfoPriceAndConditionLinkLabel) {
      <div class="d-flex justify-content-center">
        <crnt-button-alt
          variant="tertiary"
          class="mt-2"
          (click)="openMoreInfo.emit()"
          wlAutomationId="info-card-button"
          wlCSCapture
        >
          {{ content()?.moreInfoPriceAndConditionLinkLabel }}
        </crnt-button-alt>
      </div>
    }
  </div>
</ng-template>
